// extracted by mini-css-extract-plugin
export var box = "ImageStrip-module--box--3f7b1";
export var image = "ImageStrip-module--image--dbeb4";
export var inner = "ImageStrip-module--inner--b8c3d";
export var strip = "ImageStrip-module--strip--b931e";